import React from 'react';
import '../styles/onboarding-modal.css';

const GideonAssessmentModal = ({ 
  isOpen, 
  onClose, 
  onStartAssessment,
  message = "I'd love to give you personalized advice that matches your style!"
}) => {
  if (!isOpen) return null;

  return (
    <div className="suitability-modal-overlay" onClick={onClose}>
      <div className="suitability-modal" onClick={(e) => e.stopPropagation()}>
        <div className="suitability-modal-header">
          <button 
            className="modal-close-btn"
            onClick={onClose}
            title="Close"
          >
            ×
          </button>
          <div className="modal-icon">
            <img 
              src={require('../assets/images/bull-head-icon.svg').default} 
              alt="Gideon Bull" 
              className="bull-icon"
            />
          </div>
          <h2 className="modal-title">Gideon Can Be Even Better!</h2>
          <p className="modal-subtitle">
            {message}
          </p>
        </div>
        
        <div className="suitability-modal-body">
          {/* Benefits Section */}
          <div className="benefits-section">
            <div className="benefits-title">What You'll Get</div>
            <div className="benefit-item">Get personalized investment recommendations</div>
            <div className="benefit-item">Learn at your own pace</div>
          </div>
          
          {/* Gideon's Message */}
          <div className="gideon-message">
            <div className="gideon-says">Gideon Says</div>
            <div className="gideon-text">
              Hey! I'd love to help you unlock these advanced features! Let's have a quick chat so I can understand your investment style and give you personalized advice. It'll be fun and educational! 🚀
            </div>
          </div>
          
          {/* Time Indicator */}
          <div className="time-indicator">
            <span className="time-text">
              ⏱️ Takes only <strong>2-3 minutes</strong> to complete
            </span>
          </div>
        </div>
        
        <div className="suitability-modal-actions">
          <button 
            className="chat-with-gideon-btn"
            onClick={() => {
              console.log('🚀 Chat with Gideon clicked - starting assessment...');
              onStartAssessment();
              // Add a small delay to ensure onboarding flow starts before modal closes
              setTimeout(() => {
                console.log('🔄 Closing Gideon Assessment Modal...');
                onClose();
              }, 100);
            }}
          >
            Chat with Gideon
          </button>
          <button 
            className="maybe-later-btn"
            onClick={onClose}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default GideonAssessmentModal;